import { render } from "./EmailVerificationPage.vue?vue&type=template&id=70f5ff9b&ts=true"
import script from "./EmailVerificationPage.vue?vue&type=script&lang=ts"
export * from "./EmailVerificationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__